import { TFunction } from 'i18next'

export const getCarrierAccessCodeTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:packageRoomTab.carrierAccessCodeEnabled.tip')

export const getMaskUsernameTip = (t: TFunction<['packages-settings']>) =>
  t('packages-settings:packageRoomTab.maskUsernameEnabled.tip')
